import { render, staticRenderFns } from "./TextChange.vue?vue&type=template&id=c4cdf826&scoped=true&"
import script from "./TextChange.vue?vue&type=script&lang=js&"
export * from "./TextChange.vue?vue&type=script&lang=js&"
import style0 from "./TextChange.vue?vue&type=style&index=0&id=c4cdf826&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cdf826",
  null
  
)

export default component.exports